/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OsisRuleListItem,
    OsisRuleListItemFromJSON,
    OsisRuleListItemFromJSONTyped,
    OsisRuleListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface OsisRuleListItemPaginationWrapper
 */
export interface OsisRuleListItemPaginationWrapper {
    /**
     * 
     * @type {Array<OsisRuleListItem>}
     * @memberof OsisRuleListItemPaginationWrapper
     */
    items?: Array<OsisRuleListItem> | null;
    /**
     * 
     * @type {number}
     * @memberof OsisRuleListItemPaginationWrapper
     */
    totalItems?: number;
}

export function OsisRuleListItemPaginationWrapperFromJSON(json: any): OsisRuleListItemPaginationWrapper {
    return OsisRuleListItemPaginationWrapperFromJSONTyped(json, false);
}

export function OsisRuleListItemPaginationWrapperFromJSONTyped(json: any, ignoreDiscriminator: boolean): OsisRuleListItemPaginationWrapper {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(OsisRuleListItemFromJSON)),
        'totalItems': !exists(json, 'totalItems') ? undefined : json['totalItems'],
    };
}

export function OsisRuleListItemPaginationWrapperToJSON(value?: OsisRuleListItemPaginationWrapper | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(OsisRuleListItemToJSON)),
        'totalItems': value.totalItems,
    };
}


